module.exports = "﻿﻿<div class=\"wrapper wrapper-content animated fadeInRight\">\r\n    <div class=\"row\">\r\n        <div class=\"col-lg-6 col-lg-offset-3\">\r\n            <div class=\"ibox float-e-margins\">\r\n                <div class=\"ibox-content\">\r\n                    <h4>Thank you for confirming your details!</h4>\r\n                    <p><a [routerLink]=\"['/account/login']\">Log in</a> to start searching tenders.</p>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/registration/team.member.thank.you.component.html
// module id = 1214
// module chunks = 0